import { StaffChrome } from "../components/StaffChrome";
import { ReportsQueue, ListingsModeration, PendingQueue, StaffConversations, useStaffUnread } from "../components/StaffPanels";
import { ContactInbox } from "../components/ContactInbox";
import { StaffMail } from "../components/staff-mail/StaffMail";
import { SearchNicknames } from "./admin/SearchNicknames";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../components/ui/tabs";
import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useMailAlerts } from "../lib/mailAlerts";

export default function ModeratorPanel() {
  const unread = useStaffUnread();
  const [contactNew, setContactNew] = useState(0);
  const [tab, setTab] = useState("pending");
  const [openMail, setOpenMail] = useState(null);
  const [mailUnread, setMailUnread] = useMailAlerts((id) => { setTab("email"); setOpenMail({ id, at: Date.now() }); });
  useEffect(() => {
    const load = () => {
      api.get("/admin/contact-messages?status=new").then((r) => setContactNew(r.data.new_count || 0)).catch(() => {});
    };
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, []);
  return (
    <StaffChrome title="Moderator Panel">
      <h1 className="font-display text-2xl font-extrabold text-[#12234A] mb-2">Moderation Queue</h1>
      <p className="text-slate-500 mb-5">Approve new ads, review reports and moderate listings. Keep CritterPosts safe & friendly. 🐾</p>
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="bg-white border border-slate-200 rounded-xl p-1 mb-5 flex-wrap h-auto">
          <TabsTrigger value="pending" data-testid="mod-tab-pending">Pending Approval</TabsTrigger>
          <TabsTrigger value="reports" data-testid="mod-tab-reports">Reported Ads</TabsTrigger>
          <TabsTrigger value="listings" data-testid="mod-tab-listings">Listings</TabsTrigger>
          <TabsTrigger value="contact" data-testid="mod-tab-contact" className="relative">
            Contact
            {contactNew > 0 && <span data-testid="mod-contact-new-dot" className="ml-1.5 inline-flex items-center justify-center bg-[#F5551E] text-white text-[10px] font-bold rounded-full h-5 min-w-5 px-1">{contactNew}</span>}
          </TabsTrigger>
          <TabsTrigger value="email" data-testid="mod-tab-email" className="relative">
            Email
            {mailUnread > 0 && <span data-testid="mod-email-unread-dot" className="ml-1.5 inline-flex items-center justify-center bg-[#F5551E] text-white text-[10px] font-bold rounded-full h-5 min-w-5 px-1">{mailUnread}</span>}
          </TabsTrigger>
          <TabsTrigger value="nicknames" data-testid="mod-tab-nicknames">Nicknames</TabsTrigger>
          <TabsTrigger value="conversations" data-testid="mod-tab-conversations" className="relative">
            Conversations
            {unread > 0 && <span data-testid="conversations-unread-dot" className="ml-1.5 inline-flex items-center justify-center bg-[#F5551E] text-white text-[10px] font-bold rounded-full h-5 min-w-5 px-1">{unread}</span>}
          </TabsTrigger>
        </TabsList>
        <TabsContent value="pending"><PendingQueue /></TabsContent>
        <TabsContent value="reports"><ReportsQueue /></TabsContent>
        <TabsContent value="listings"><ListingsModeration /></TabsContent>
        <TabsContent value="contact"><ContactInbox onCountChange={setContactNew} /></TabsContent>
        <TabsContent value="email"><StaffMail onCountChange={setMailUnread} openRequest={openMail} liveUnread={mailUnread} /></TabsContent>
        <TabsContent value="nicknames"><SearchNicknames /></TabsContent>
        <TabsContent value="conversations"><StaffConversations /></TabsContent>
      </Tabs>
    </StaffChrome>
  );
}
